import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import styles from "./index.module.scss";
import Step1 from "../../pages/personal/cart/step1";
import {
  getCartData,
  getDeliveryList,
  getPaymentList,
  getStep,
} from "../../../redux/action-creaters/cart";

export default function ManagerDelivery() {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getDeliveryList());
    dispatch(getPaymentList());
  }, []);

  const { isBasketLoaded } = useSelector((state) => state.cart);
  const { cityName, deliveryCityData } = useSelector((state) => state.location);
  const { user, isUserLoaded } = useSelector((state) => state.user);

  useEffect(() => {
    if (isUserLoaded && isBasketLoaded && cityName) {
      dispatch(getCartData(user, cityName, deliveryCityData?.region_with_type));
      dispatch(getStep());
    }
  }, [cityName, deliveryCityData, isUserLoaded, isBasketLoaded]);

  return (
    <div className={styles.Wrapper}>
      <div>
        <h2>Рассчет доставки</h2>

        <Step1 isManagerDelivery={true} />
      </div>
    </div>
  );
}
